import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/limitless-deprecated/deprecated-core2.css';
/* BASE CSS */
import 'css/src/entry-points/auth-base';

import React from 'react';

import LoginPage from 'js/src/components/auth/login';
import { initCookieConsent } from 'js/src/libs/cookie-consent';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { renderComponent } from 'js/src/libs/redux-utils';

initCookieConsent();
ErrorReporter.init(Project.FRONTEND);

const LoginPageContainer = React.memo(function Login() {
    return <LoginPage />;
});

renderComponent(LoginPageContainer);
